import type {
  Category,
  Product,
  Quote,
  QuoteFormItem,
  DelayQuoteRecord,
  DelayQuoteRecordParams,
  OrderForm,
  OrderItem,
  AfterSalesForm,
  AfterSalesRecord,
  OrderParams,
  StatisticalData,
  AfterSalesParams,
  SupplyDemand,
  TransactionDetail,
  SuccessRate,
  TransactionTrend
} from '@xianlaibang/shared/types'

interface ApiAddOrder {
  batchOrderNumber: string
  successCount: number
  invalidPhones: string[]
  intercepts: string[]
  code: number
  msg: string
}

export const productApi = {
  // 产品类别列表
  getCategoryList: () => {
    const { get } = useHttp()
    return get<Category[]>('/product/productCategory')
  },
  // 指定产品品类下的产品列表
  getProductList: (productCategoryId: number) => {
    const { get } = useHttp()
    return get<Product[]>('/recharge/rechargeQuote/goodsList', { productCategoryId })
  },
  // 指定产品下的报价表
  getProductQuoteList: (queryParams: { productCategoryId: number, rechargeGoodsId: number }) => {
    const { get } = useHttp()
    return get<Quote[]>(`/recharge/userQuote`, queryParams)
  },
  // 获取延时调价记录
  getRecordEffect: (queryParams: DelayQuoteRecordParams) => {
    const { get } = useHttp()
    return get<null, DelayQuoteRecord>(`/recharge/userQuote/record`, queryParams)
  },
  // 添加报价区域
  addProductQuoteLocation: (rechargeQuoteId: number | null, locations: string[]) => {
    if (!rechargeQuoteId) return
    const { post } = useHttp()
    return post<null, Quote[]>(`/recharge/userQuote/addLocation`, { rechargeQuoteId, locations })
  },
  // 添加报价
  addProductQuote: (priceItems: QuoteFormItem[], enableTime: string) => {
    const { post } = useHttp()
    return post<Quote>(`/recharge/userQuote/userItem`, { priceItems, enableTime })
  },
  // 话费帮充放单
  addOrder: (data: OrderForm) => {
    const { post } = useHttp()
    return post<ApiAddOrder>(`/recharge/purchaseOrder`, data)
  },
  // 话费帮充订单列表
  getOrder: (query: OrderParams) => {
    const { get } = useHttp()
    return get<StatisticalData, OrderItem>(`/recharge/purchaseOrder`, query)
  },
  // 取消话费帮充订单
  cancelOrder: (rechargePurchaseOrderId: number) => {
    const { post } = useHttp()
    return post<string | null>(`/recharge/purchaseOrder/cancel`, { rechargePurchaseOrderId })
  },
  // 采购用户发起售后
  addAfterSales: (data: AfterSalesForm) => {
    const { post } = useHttp()
    return post<null | string>(`/recharge/afterSales/purchase`, data)
  },
  // 采购用户获取售后记录
  getAfterSalesList: (query: AfterSalesParams) => {
    const { get } = useHttp()
    return get<null, AfterSalesRecord>(`/recharge/afterSales`, query)
  },
  // 采购用户获取售后详情
  getAfterSales: (businessOrder: string, businessType: string) => {
    const { get } = useHttp()
    return get<AfterSalesRecord|null>(`/recharge/afterSales/${businessOrder}`, { businessType })
  },
  // 获取供采行情
  getSupplyDemand: ( quoteId: number, productCategoryId: number) => {
    const { get } = useHttp()
    return get<{ supplyList: SupplyDemand[], purchaseList: SupplyDemand[] }>(`/recharge/purchaseOrder/${quoteId}/purchaseMarketSupply/${productCategoryId}`)
  },
  // 获取成交明细数据
  getTransactionDetail: (quoteId: number) => {
    const { get } = useHttp()
    return get<TransactionDetail[]>(`/recharge/purchaseOrder/${quoteId}/transactionDetails`)
  },
  // 获取24小时成功率数据
  getSuccessRate: (quoteId: number) => {
    const { get } = useHttp()
    return get<SuccessRate[]>(`/recharge/purchaseOrder/${quoteId}/transactionRate`)
  },
  // 获取30日成交走势数据
  getTransactionTrend: (quoteId: number) => {
    const { get } = useHttp()
    return get<TransactionTrend[]>(`/recharge/purchaseOrder/${quoteId}/transactionTrend`)
  }
}
